import { getIcons } from '@/api/icons'
import {
  SET_LIST_ICON,
  SET_ICON_GALLERIES
} from '@/store/mutation-types'

const fetchListIcons = ({state, commit}, params = {limit: -1}) => {
  if (!state.iconsFetched) {
    commit('SET_ICONS_FETCHED', true)
    getIcons(params).then(async function (response) {
      switch (response.status) {
        case 1:
          commit(SET_LIST_ICON, response.data)
          let data = {
            'point': [],
            'info': [],
            'image': [],
            'patch': [],
            'pip': []
          }
          for (let i = 0; i < response.data.length; i++) {
            switch (response.data[i].hotspot_type) {
              case 'point':
                data['point'].push(response.data[i])
                break
              case 'info':
                data['info'].push(response.data[i])
                break
              case 'image':
                data['image'].push(response.data[i])
                break
              case 'patch':
                data['patch'].push(response.data[i])
                break
              case 'pip':
                data['pip'].push(response.data[i])
                break
              default:
                break
            }
          }
          commit(SET_ICON_GALLERIES, data)
          break
        default:
          break
      }
    })
  }
}

export default {
  fetchListIcons
}



// WEBPACK FOOTER //
// ./src/components/icon/store/actions.js